<template>
    <div>
        <b-card header-tag="header" border-variant="danger">
            <template slot="header">
                <b-row>
                    <b-col cols="0" sm="0"	md="5"	lg="5"	xl="1">
                        <div class="col-md-12 text-left">
                            <b-button variant="danger" @click="listaCobrosxAprobar"><i class="fa fa-sync-alt"></i> </b-button>
                        </div>    
                    </b-col>
                    <b-col cols="12" sm="10" md="10"	lg="10"	xl="4">
                    </b-col>
                    <b-col cols="12" sm="12"	md="7"	lg="7"	xl="3">
                        <div class="negritatitle">CUENTAS POR PAGAR <b-badge variant="danger">Pendientes de aprobacion</b-badge></div>
                    </b-col>
                    <b-col cols="4" sm="4"	md="2"	lg="2"	xl="2">
                       <b-form-group horizontal label="Orden" class="mb-0">
                            <b-input-group>
                            <b-form-select v-model="orden" slot="append" @input="listaCobrosxAprobar">
                                <option :value="'asc'">Más Antiguo</option>
                                <option :value="'desc'">Más Reciente</option>
                            </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4" sm="4"	md="2"	lg="2"	xl="2">
                       <b-form-group horizontal label="Mostrar" class="mb-0">
                            <b-input-group>
                                <b-form-select v-model="limite" slot="append" @input="listaCobrosxAprobar">
                                <option :value="10">10</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="100">100</option>
                                </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <b-table 
                striped 
                hover 
                small 
                responsive
                outlined
                :filter="filter_pendientes"
                :busy="isBusy"
                :items="cuentasxAprobar" 
                :fields="xaprobar_fields"
                >
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                </div>
                <template slot="antiguedad" slot-scope="row">
                    <i v-if="row.item.morosidadtotal === 1" class="fa fa-smile fa-2x text-success"></i>
                    <i v-else-if="row.item.morosidadtotal === 2" class="fa fa-meh fa-2x text-warning"></i>
                    <i v-else-if="row.item.morosidadtotal === 3" class="fa fa-frown fa-2x text-danger"></i>
                </template>
                <template slot="cantidad" slot-scope="row">
                    {{ row.item.cantidad }}
                </template>
                <template slot="receptor" slot-scope="row">
                    {{ row.item.idEmisor }} - {{ row.item.emitter.razonSocial }}
                </template>
                <template slot="estado" slot-scope="row">
                    <template v-if="row.item.emitter.estado === 'ACTIVO'">
                        <b-badge pill variant="primary">Activo</b-badge>
                    </template>
                    <template v-else>
                        <b-badge pill variant="secondary">Baja</b-badge>
                    </template>
                </template>
                <template slot="deudatotalSoles" slot-scope="row">
                    <div v-if="row.item.deudatotalSoles > 0">
                        S/ {{row.item.deudatotalSoles.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadasoles" slot-scope="row">
                    <div v-if="row.item.deudatotalSoles-row.item.deudapagadasoles > 0">
                        S/ {{(row.item.deudatotalSoles-row.item.deudapagadasoles).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudatotalDolares" slot-scope="row">
                    <div v-if="row.item.deudatotalDolares > 0">
                        $ {{row.item.deudatotalDolares.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadaDolares" slot-scope="row">
                    <div v-if="row.item.deudatotalDolares-row.item.deudapagadaDolares > 0">
                        $ {{(row.item.deudatotalDolares-row.item.deudapagadaDolares).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="acciones" slot-scope="row">
                    <button
                        v-show="!row.item.loading"
                        type="button"
                        class="btn"
                        size="sm"
                        @click="mostrarDetalles(row, 1, row.index)"
                        title="Mas opciones"
                        >
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                    <b-button size="sm" v-show="row.item.loading" variant="ligth">
                        <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                    <b-button size="sm" v-b-modal.infopago class="ml-2 p-0 m-0" variant="success" v-b-tooltip.hover @click="informacionPagos(row.item)"><i title="Informacion pagos" class="fa fa-comment-dollar fa-2x"></i></b-button>
                </template>
                <template slot="row-details" slot-scope="row">
                    <b-card border-variant="primary">
                        <b-table striped hover :items="row.item.detalles" :fields="docxaprobar_fields" :busy="row.item.loading">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> Cargando...</strong>
                            </div>
                            <template slot="antiguedad" slot-scope="row">
                                <i v-if="row.item.morosidad === 1" class="fa fa-smile fa-2x text-success"></i>
                                <i v-else-if="row.item.morosidad === 2" class="fa fa-meh fa-2x text-warning"></i>
                                <i v-else-if="row.item.morosidad === 3" class="fa fa-frown fa-2x text-danger"></i>
                            </template>
                            <template slot="emision" slot-scope="row">
                                {{ row.item.fechaEmision | moment('D/M/Y') }}
                            </template>
                            <template slot="vencimiento" slot-scope="row">
                                {{ row.item.vencimiento | moment('D/M/Y') }}
                            </template>
                            <template slot="tiempo" slot-scope="row">
                                <div>
                                    {{ row.item.fechaEmision | moment('from') }}
                                </div>
                            </template>
                            <template slot="estado" slot-scope="row">
                                <template v-if="row.item.aprobado===0">
                                    <b-badge pill variant="info">Pendiente</b-badge>
                                </template>
                                <template v-else-if="row.item.aprobado===2">
                                    <b-badge pill variant="warning">Observado</b-badge>
                                </template>
                            </template>
                            <template slot="deudatotalSoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles > 0">
                                    S/ {{row.item.importeTotalSoles.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="parcialsoles" slot-scope="row">
                                <div v-if="row.item.importePagadoSoles > 0">
                                    S/ {{row.item.importePagadoSoles.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudapagadasoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles-row.item.importePagadoSoles > 0">
                                    S/ {{(row.item.importeTotalSoles-row.item.importePagadoSoles).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudatotalDolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares > 0">
                                    $ {{row.item.importeTotalDolares.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="parcialdolares" slot-scope="row">
                                <div v-if="row.item.importePagadoDolares > 0">
                                    S/ {{row.item.importePagadoDolares.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudapagadaDolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares-row.item.importePagadoDolares > 0">
                                    $ {{(row.item.importeTotalDolares-row.item.importePagadoDolares).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="acciones" slot-scope="row">
                                <b-button size="sm" v-b-modal.prevmodal v-b-tooltip.hover title="Vista Previa" @click="viewPdf(row.item)"><i class="fa fa-tv"></i></b-button>
                                <b-button size="sm" variant="primary" v-show="!row.item.mostrardetalles" class="ml-2" v-b-tooltip.hover title="Aprobar" @click="estadoCuenta(row, 1, row.index)"><i class="fa fa-check"></i></b-button>
                                <b-button size="sm" v-show="row.item.mostrardetalles" variant="ligth"><i class="fa fa-spin fa-spinner"></i></b-button>
                                <b-button size="sm" v-b-modal.motivorechazo v-b-tooltip.hover variant="warning" title="Observar" class="ml-2" @click="estadoCuenta(row, 2, row.index)"><i class="fa fa-exclamation-triangle "></i></b-button>
                            </template> 
                        </b-table>
                    </b-card>
                </template>
            </b-table>
            <b-row>
                <b-col cols="12" sm="6"	md="6"	lg="6"	xl="6">
                    <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                </b-col>
                <b-col cols="12" sm="6"	md="6"	lg="6"	xl="6">
                    <div class="float-right">
                        <b-pagination size="sm" :total-rows="total" v-model="currentPage" @input="listaCobrosxAprobar" :per-page="limite"></b-pagination>
                    </div>            
                </b-col>
            </b-row>
        </b-card>
        <b-card header-tag="header" border-variant="dark">
            <template slot="header">
                <b-row>
                    <b-col cols="0" sm="0"	md="5"	lg="5"	xl="1">
                        <div class="col-md-12 text-left">
                            <b-button variant="dark" @click="listaCobrosAprobadas"><i class="fa fa-sync-alt"></i> </b-button>
                        </div>    
                    </b-col>
                    <b-col cols="12" sm="10" md="10"	lg="10"	xl="4">
                    </b-col> 
                    <b-col cols="12" sm="12"	md="7"	lg="7"	xl="3">
                        <div class="negritatitle">CUENTAS POR PAGAR <b-badge variant="dark">Aprobadas</b-badge></div>
                    </b-col>
                    <b-col cols="4" sm="4"	md="2"	lg="2"	xl="2">
                       <b-form-group horizontal label="Orden" class="mb-0">
                            <b-input-group>
                            <b-form-select v-model="ordenA" slot="append" @input="listaCobrosAprobadas">
                                <option :value="'asc'">Más Antiguo</option>
                                <option :value="'desc'">Más Reciente</option>
                            </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4" sm="4"	md="2"	lg="2"	xl="2">
                       <b-form-group horizontal label="Mostrar" class="mb-0">
                            <b-input-group>
                                <b-form-select v-model="limiteA" slot="append" @input="listaCobrosAprobadas">
                                <option :value="10">10</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="100">100</option>
                                </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <b-table 
                striped 
                hover 
                small 
                responsive
                outlined
                :filter="filter_aprobadas"
                :busy="aprobados"
                :items="cuentasAprobadas" 
                :fields="xaprobar_fields"
                >
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                </div>
                <template slot="antiguedad" slot-scope="row">
                    <i v-if="row.item.morosidadtotal === 1" class="fa fa-smile fa-2x text-success"></i>
                    <i v-else-if="row.item.morosidadtotal === 2" class="fa fa-meh fa-2x text-warning"></i>
                    <i v-else-if="row.item.morosidadtotal === 3" class="fa fa-frown fa-2x text-danger"></i>
                </template>
                <template slot="cantidad" slot-scope="row">
                    {{ row.item.cantidad }}
                </template>
                <template slot="receptor" slot-scope="row">
                    {{ row.item.emitter.idEmisor }} - {{ row.item.emitter.razonSocial }}
                </template>
                <template slot="estado" slot-scope="row">
                    <template v-if="row.item.emitter.estado === 'ACTIVO'">
                        <b-badge pill variant="primary">Activo</b-badge>
                    </template>
                    <template v-else>
                        <b-badge pill variant="secondary">Baja</b-badge>
                    </template>
                </template>
                <template slot="deudatotalSoles" slot-scope="row">
                    <div v-if="row.item.deudatotalSoles > 0">
                        S/ {{row.item.deudatotalSoles.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadasoles" slot-scope="row">
                    <div v-if="row.item.deudatotalSoles-row.item.deudapagadasoles > 0">
                        S/ {{(row.item.deudatotalSoles-row.item.deudapagadasoles).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudatotalDolares" slot-scope="row">
                    <div v-if="row.item.deudatotalDolares > 0">
                        $ {{row.item.deudatotalDolares.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadaDolares" slot-scope="row">
                    <div v-if="row.item.deudatotalDolares-row.item.deudapagadaDolares > 0">
                        $ {{(row.item.deudatotalDolares-row.item.deudapagadaDolares).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="acciones" slot-scope="row">
                    <button
                        v-show="!row.item.loading"
                        type="button"
                        class="btn"
                        size="sm"
                        @click="mostrarDetalles(row, 2, row.index)"
                        title="Mas opciones"
                        >
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                    <b-button size="sm" v-show="row.item.loading" variant="ligth">
                        <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                    <b-button size="sm" v-b-modal.infopago class="ml-2 p-0 m-0" variant="success" v-b-tooltip.hover @click="informacionPagos(row.item)"><i title="Informacion pagos" class="fa fa-comment-dollar fa-2x"></i></b-button>
                </template>
                <template slot="row-details" slot-scope="row">
                    <b-card border-variant="primary">
                        <b-table striped hover :items="row.item.detalles" :fields="docxaprobar_fields" :busy="row.item.loading">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> Cargando...</strong>
                            </div>
                            <template slot="antiguedad" slot-scope="row">
                                <i v-if="row.item.morosidad === 1" class="fa fa-smile fa-2x text-success"></i>
                                <i v-else-if="row.item.morosidad === 2" class="fa fa-meh fa-2x text-warning"></i>
                                <i v-else-if="row.item.morosidad === 3" class="fa fa-frown fa-2x text-danger"></i>
                            </template>
                            <template slot="emision" slot-scope="row">
                                {{ row.item.fechaEmision | moment('D/M/Y') }}
                            </template>
                            <template slot="vencimiento" slot-scope="row">
                                {{ row.item.vencimiento | moment('D/M/Y') }}
                            </template>
                            <template slot="tiempo" slot-scope="row">
                                <div>
                                    {{ row.item.fechaEmision | moment('from') }}
                                </div>
                            </template>
                            <template slot="estado" slot-scope="row">
                                <template v-if="row.item.aprobado===1">
                                    <b-badge pill variant="success">Aprobado</b-badge>
                                </template>
                            </template>
                            <template slot="deudatotalSoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles > 0">
                                    S/ {{row.item.importeTotalSoles.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="parcialsoles" slot-scope="row">
                                <div v-if="row.item.importePagadoSoles > 0">
                                    S/ {{row.item.importePagadoSoles.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudapagadasoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles-row.item.importePagadoSoles > 0">
                                    S/ {{(row.item.importeTotalSoles-row.item.importePagadoSoles).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudatotalDolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares > 0">
                                    $ {{row.item.importeTotalDolares.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="parcialdolares" slot-scope="row">
                                <div v-if="row.item.importePagadoDolares > 0">
                                    S/ {{row.item.importePagadoDolares.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudapagadaDolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares-row.item.importePagadoDolares > 0">
                                    $ {{(row.item.importeTotalDolares-row.item.importePagadoDolares).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="acciones" slot-scope="row">
                                <b-button size="sm" v-b-modal.prevmodal v-b-tooltip.hover title="Vista Previa" @click="viewPdf(row.item)"><i class="fa fa-tv"></i></b-button>
                                <b-button size="sm" v-b-modal.crearnotificacion v-b-tooltip.hover title="Comunicar pago" class="ml-2" variant="success" @click="getidDocumentoCredito(row)"><i class="fa fa-comments-dollar"></i></b-button>
                                <b-button size="sm" v-b-modal.listarpagos v-b-tooltip.hover variant="primary" class="ml-2" @click="watchPayment(row)"><i class="fa fa-eye" title="Listar Pagos"></i></b-button>
                            </template> 
                        </b-table>
                    </b-card>
                </template>
            </b-table>
            <b-row>
                <b-col cols="12" sm="6"	md="6"	lg="6"	xl="6">
                    <p>Mostrando del {{desdeA}} al {{hastaA}} de un total de {{totalA}} registros</p>
                </b-col>
                <b-col cols="12" sm="6"	md="6"	lg="6"	xl="6">
                    <div class="float-right">
                        <b-pagination size="sm" :total-rows="total" v-model="currentPageA" @input="listaCobrosAprobadas" :per-page="limiteA"></b-pagination>
                    </div>            
                </b-col>
            </b-row>
        </b-card>
        <b-modal id="listarpagos" size="lg" title="Listar Pagos" v-model="listarPagos">
            <div>
                <b-alert v-if="Object.keys(encabezadosCliente).length != 0" show variant="warning" class="text-center">
                    <b>Cliente: </b> 
                    {{ encabezadosCliente.emitter.idEmisor }}-{{ encabezadosCliente.emitter.razonSocial }}
                </b-alert>
                <b-table :fields="pagos_fields" :items="listaPagos" :busy="cargandopagos">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="emision" slot-scope="row">
                        {{ row.item.fechaEmision | moment('D/M/Y') }}
                    </template>
                    <template slot="importe" slot-scope="row">
                        <template v-if="row.item.tipoMoneda == 'PEN'">
                            S/ {{ row.item.importePagado }}
                        </template>
                        <template v-else-if="row.item.tipoMoneda == 'USD'">
                            $ {{ row.item.importePagado }}
                        </template>
                    </template>
                    <template slot="observaciones" slot-scope="row">
                        {{ row.item.observaciones }}
                    </template>
                </b-table>               
            </div>
            <div slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-right" variant="danger" @click="cerrarlistapagos">
                    Cerrar
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="infopago" size="lg" title="Listar Pagos" v-model="inforpago">
            <div>
                <b-alert v-if="Object.keys(encabezadosCliente).length != 0" show variant="warning" class="text-center">
                    <b>Cliente: </b> 
                    {{ encabezadosCliente.emitter.idEmisor }}-{{ encabezadosCliente.emitter.razonSocial }}
                </b-alert>
                <b-table :fields="infopago_fields" :items="listaInformacionPagos" :busy="cargandoinfopagos">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                </b-table>               
            </div>
            <div slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-right" variant="danger" @click="cerrarinfopago">
                    Cerrar
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="motivorechazo" size="md" title="Motivo Rechazo" v-model="motivorechazo">
            <div role="group">
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-form-textarea
                            v-model="observaciones"
                            placeholder="Observaciones..."
                            rows="3"
                            max-rows="12"
                        ></b-form-textarea>
                    </b-col>
                </b-row>
            </div>
            <div slot="modal-footer" class="w-100">
                <b-btn v-if="!enviando" size="sm" :disabled="validateRechazo()" class="float-right" variant="primary" @click="enviarRechazo()">
                    Enviar
                </b-btn>
                <b-btn v-else size="sm" class="float-right" variant="secondary">
                    <i class="fa fa-spin fa-spinner"></i> Enviando...
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="crearnotificacion" size="lg" title="Informar Pago" v-model="crearnotificacion">
            <div role="group">
                <b-alert v-if="Object.keys(encabezadosCliente).length != 0" show variant="warning" class="text-center">
                    <b>Cliente: </b> 
                    {{ encabezadosCliente.emitter.idEmisor }}-{{ encabezadosCliente.emitter.razonSocial }}
                </b-alert>
                <b-row>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="tipodebanco">
                            <option :value="banco" v-for="banco in Bancos" v-bind:key="banco.id">
                                {{ banco.descripcion }}
                            </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <datepicker v-model="femision" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <b-form-input v-model="importe" type="text" placeholder="Monto"></b-form-input>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <select disabled class="custom-select mr-sm-2 input-placedark input-dark" v-model="tipodemoneda">
                            <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                {{ moneda.descripcion }}
                            </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <b-form-input v-model="operacion" type="text" placeholder="Nro. Operacion"></b-form-input>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-form-textarea
                            v-model="observacionespago"
                            placeholder="Observaciones"
                            rows="3"
                            max-rows="12"
                        ></b-form-textarea>
                    </b-col>
                </b-row>
            </div>
            <div slot="modal-footer" class="w-100">
                <b-btn v-if="!enviandonotificacion" :disabled="checknotifiacion()" size="sm" class="float-right" variant="primary" @click="sendNotificacion()">
                    Enviar
                </b-btn>
                <b-btn v-else size="sm" class="float-right" variant="secondary">
                    <i class="fa fa-spin fa-spinner"></i> Enviando...
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="prevmodal" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previewmodal">
            <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
            <template v-else>
            <template v-if="pdfobject !==''">
                <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
            </template>
        </b-modal>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import { TipoMoneda } from '@/shared/utils'
import Datepicker from 'vuejs-datepicker'
    export default {
        name: 'CuentaPagar',
        components: {
            Datepicker
        },
        data:() => {
            return {
                total: 0.00,
                desde: 0.00,
                hasta: 0.00,
                limite: 50,
                orden: 'desc',
                currentPage: 1,
                totalA: 0.00,
                desdeA: 0.00,
                hastaA: 0.00,
                limiteA: 50,
                ordenA: 'desc',
                currentPageA: 1,
                f1: '',
                f2: '',
                filter_pendientes: null,
                filter_aprobadas: null,
                listaInformacionPagos: [],
                cargandoinfopagos: false,
                infopago_fields: [
                    {key: 'banco', label: 'Banco', sortable: true},
                    {key: 'tipoCuenta', label: 'Tipo Cuenta', sortable: true},
                    {key: 'moneda', label: 'Moneda', sortable: true},
                    {key: 'numeroCuenta', label: 'Numero Cuenta', sortable: true},
                    {key: 'cci', label: 'Interbancario', sortable: true}
                ],
                inforpago: false,
                listarPagos: false,
                listaPagos: [],
                cargandopagos: false,
                pagos_fields: [
                    {key: 'emision', label: 'Fecha de Registro', sortable: true},
                    {key: 'importe', label: 'Importe', sortable: true},
                    {key: 'observaciones', label: 'Observaciones', sortable: true}
                ],
                currentdate: '',
                importe: '',
                operacion: '',
                tipodemoneda: {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                femision: '',
                Bancos: [
                    {id: 0 , descripcion: 'BCP'},
                    {id: 1 , descripcion: 'BBVA'},
                    {id: 2 , descripcion: 'Interbank'},
                    {id: 3 , descripcion: 'Scotiabank Perú'},
                    {id: 4 , descripcion: 'PICHINCHA'},
                    {id: 5 , descripcion: 'MiBanco'},
                    {id: 6 , descripcion: 'BanBif'},
                    {id: 7 , descripcion: 'Banco de Comercio'},
                    {id: 8 , descripcion: 'Banco Pichincha'},
                    {id: 9 , descripcion: 'Citibank Perú'},
                    {id: 10 , descripcion: 'Banco GNB Perú'},
                    {id: 11 , descripcion: 'Banco Falabella'}
                ],
                tipodebanco: {
                    id: 0 , 
                    descripcion: 'BCP'
                },
                tipoMoneda: TipoMoneda,
                enviando: false,
                enviandopago: false,
                motivorechazo: false,
                observaciones: '',
                isBusy: false,
                isBusy2: false,
                xaprobar_fields: [
                    {key: 'antiguedad', label: '', _showDetails: false},
                    {key: 'cantidad', label: 'Nº Doc.', sortable: true, _showDetails: false},
                    {key: 'receptor', label: 'Receptor', sortable: false, _showDetails: false},
                    {key: 'deudatotalSoles', label: 'Total Soles', sortable: true, _showDetails: false},
                    {key: 'deudapagadasoles', label: 'Deuda Soles', sortable: true, _showDetails: false},
                    {key: 'deudatotalDolares', label: 'Total Dolares', sortable: true, _showDetails: false},
                    {key: 'deudapagadaDolares', label: 'Deuda Dolares', sortable: true, _showDetails: false},
                    {key: 'acciones', label: 'Acciones', _showDetails: false}
                ],
                docxaprobar_fields: [
                    {key: 'antiguedad', label: ''},
                    {key: 'serie', label: 'Serie', sortable: true},
                    {key: 'numero', label: 'Numero', sortable: false},
                    {key: 'emision', label: 'Emision', sortable: false},
                    {key: 'vencimiento', label: 'Vencimiento', sortable: false},
                    {key: 'tiempo', label: 'Tiempo', sortable: false},
                    {key: 'estado', label: 'Estado', sortable: false},
                    {key: 'deudatotalSoles', label: 'Total S/', sortable: true, _showDetails: false},
                    {key: 'parcialsoles', label: 'Parcial S/', sortable: true, _showDetails: false},
                    {key: 'deudapagadasoles', label: 'Deuda S/', sortable: true, _showDetails: false},
                    {key: 'deudatotalDolares', label: 'Total US$', sortable: true, _showDetails: false},
                    {key: 'parcialdolares', label: 'Parcial US$', sortable: true, _showDetails: false},
                    {key: 'deudapagadaDolares', label: 'Deuda US$', sortable: true, _showDetails: false},
                    {key: 'acciones', label: 'Acciones'}
                ],
                cuentasxAprobar: [],
                cuentasAprobadas: [],
                creditos: [],
                rechazo: false,
                aprobados: false,
                pdfobject: '',
                previewmodal: false,
                cargandopdf2: false,
                indexApobar: 0,
                indexApobado: 0,
                comunicarpago: false,
                filaActual: {},
                encabezadosCliente: {},
                registropagotipo: 0,
                enviandonotificacion: false,
                idDocumentoCredito: '',
                observacionespago: '',
                notificaciones: [],
                crearnotificacion: false,
                serie: '',
                numero: ''
            }
        },
        mounted(){
            this.listaCobrosxAprobar(),
            this.listaCobrosAprobadas(),
            this.initDates()
        },
        methods: {
            cerrarinfopago: function () {
                this.inforpago = false
            },
            informacionPagos: function (data) {
                this.encabezadosCliente = data
                this.cargandoinfopagos = true
                axios
                .post(process.env.VUE_APP_API_URL + 'infobanco/buscarxruc',{
                    token: this.$store.getters.userToken,
                    ruc: data.idEmisor
                })
                .then(response => (
                    this.responseInformacionPagos(response.data.response)
                ))  
                .catch(error => (
                    this.cargandoinfopagos = false
                )) 
            },
            responseInformacionPagos: function (value) {
                if(value.length > 0){
                    this.listaInformacionPagos = value,
                    this.cargandoinfopagos = false
                }else{
                    this.inforpago = false,
                    this.listaInformacionPagos = [],
                    this.$snotify.warning('No se encontro información de pago','Cuidado')
                }
            },
            cerrarlistapagos: function () {
                this.listarPagos = false
            },
            watchPayment: function (row) {
                this.listaPagos = []
                this.cargandopagos = true
                 axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/pagoreceptor/listar',{
                    token: this.$store.getters.userToken,
                    id: row.item.idDocumentoCredito
                })
                .then(response => (
                    this.cargandopagos = false,
                    this.respuestaListaPago(response.data)
                ))  
                .catch(error => (
                    this.cargandopagos = false,
                    this.$snotify.error(error.response.data.message,'Error')
                )) 
            },
            respuestaListaPago: function (respuesta) {
                if(respuesta.success == 0){
                    this.listarPagos = false,
                    this.$snotify.warning(respuesta.msg,'Importante')
                }else if(respuesta.success == 1){
                    this.listaPagos = respuesta.msg
                }
            },
            validateRechazo: function () {
                if(this.observaciones != ''){
                    return false
                }else{
                    return true
                }
            },
            initDates: function () {    
                this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
            },
            customFormatter: function (date) {
                return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            },
            checknotifiacion: function () {
                if(this.importe != '' && this.operacion != ''){
                    return false
                }else{
                    return true
                }
            },
            sendNotificacion: function () {
                let emision = ''
                if(this.femision != ''){
                    emision = this.femision
                }else{
                    emision = this.currentdate
                }
                let notificacion = {
                    serie: this.serie,
                    numero: this.numero,
                    importe: this.importe,
                    tipomoneda: this.tipodemoneda.codigo,
                    banco: this.tipodebanco.descripcion,
                    nrooperacion: this.operacion,
                    fechaemision: emision,
                    observacion: this.observacionespago
                }
                this.enviandonotificacion = true
                this.notificaciones.push(notificacion)
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/pagoreceptor/alerta',{
                    token: this.$store.getters.userToken,
                    iddocumentocredito: this.idDocumentoCredito,
                    alerta: this.notificaciones
                })
                .then(response => (
                    this.notificacion = '',
                    this.enviandonotificacion = false,
                    this.crearnotificacion = false,
                    this.$snotify.success(response.data.msg,'Exito'),
                    this.initnotificacion()
                ))  
                .catch(error => (
                    this.crearnotificacion = false,
                    this.enviandonotificacion = false,
                    this.$snotify.error(error.response.data.message,'Error')
                )) 
            },  
            getidDocumentoCredito: function (row) {
                this.idDocumentoCredito = row.item.idDocumentoCredito
                this.serie = row.item.serie,
                this.numero = row.item.numero
                if(row.item.tipoMoneda == 'PEN'){
                    this.importe = row.item.importeTotalSoles
                }else if(row.item.tipoMoneda == 'USD'){
                    this.importe = row.item.importeTotalDolares
                }
            },
            initnotificacion: function () {
                this.idDocumentoCredito = '',
                this.serie = '',
                this.numero = '',
                this.importe = '',
                this.observacionespago = '',
                this.operacion = ''
            },
            viewPdf: function (data) {
                this.previewmodal = true,
                this.pdfobject = '',
                this.cargandopdf2 = true
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/receptores/pdf',{
                    token: this.$store.getters.userToken,
                    id: data.idDocumento,
                    emisor: data.emitter.idEmisor,
                    tipodocumento: data.tipoDocumento
                })
                .then(response => (
                    this.pdfobject = response.data.base64,
                    this.cargandopdf2 = false
                ))
                .catch(error => {})
            },
            informarPago: function (row, tipo) {
                // Falta ruta para informar pago
            },
            mostrarDetalles: function (row, tipo, index) {
                this.encabezadosCliente = row.item
                this.indexApobar = 0
                this.indexApobado = 0
                if(tipo === 1){
                    if(row.detailsShowing){
                        row.toggleDetails()
                        this.cuentasxAprobar[index].mostrardetalles = false
                    }else{
                        this.cuentasxAprobar[index].mostrardetalles = true
                        this.cuentasxAprobar[index].loading = true
                        this.indexApobar = index
                        if (this.cuentasxAprobar[index].detalles.length == 0) {
                            setTimeout(() => this.detallesDocumento(row, 1), 10);
                        } else {
                            this.cuentasxAprobar[index].loading = false;
                            row.toggleDetails();
                        }
                    }
                }else if(tipo === 2){
                    if(row.detailsShowing){
                        row.toggleDetails()
                        this.cuentasAprobadas[index].mostrardetalles = false
                    }else{
                        this.cuentasAprobadas[index].mostrardetalles = true
                        this.cuentasAprobadas[index].loading = true
                        this.indexApobado = index
                        if (this.cuentasAprobadas[index].detalles.length == 0) {
                            setTimeout(() => this.detallesDocumento(row, 2), 10);
                        } else {
                            this.cuentasAprobadas[index].loading = false;
                            row.toggleDetails();
                        }
                    }
                } 
            },
            estadoCuenta: function (row, estado, index) {
                this.creditos = []
                let credito = {
                    id: '',
                    aprobado:'',
                    observaciones: ''
                }
                if(estado === 1){
                    credito.id = row.item.idDocumentoCredito,
                    credito.aprobado = 1,
                    credito.observaciones = '',
                    row.item.mostrardetalles = true,
                    // this.check = true,
                    this.creditos.push(credito)
                    this.sendCreditos(row, 1)
                }else if(estado === 2){
                    credito.id = row.item.idDocumentoCredito,
                    credito.aprobado = 2,
                    credito.observaciones = '',
                    this.creditos.push(credito),
                    this.rechazo = true
                }
                this.filaActual = row,
                this.registropagotipo = estado
                // this.idReceptor = row.item.idDocumentoCredito
            },
            enviarRechazo: function () {
                if(this.rechazo && this.creditos.length > 0){
                    this.creditos[0].observaciones = this.observaciones 
                    this.sendCreditos(this.filaActual, 2)
                }
            },
            sendCreditos: function (row, tipo) {
                this.enviando = true
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/aprobar',{
                    token: this.$store.getters.userToken,
                    creditos: this.creditos
                })
                .then(response => (
                    this.refresh(response.data, row, tipo)
                ))
                .catch(error => (
                    this.enviando = false
                    // this.$snotify.error(error.response.data.msg,'Error')
                ))
            },  
            refresh: function (response, row, tipo) {
                if(tipo === 1){
                    row.item.mostrardetalles = false,
                    this.enviando = false,
                    this.$snotify.success(response.msg,'Exito'),
                    this.listaCobrosAprobadas(),
                    this.mostrarDetalles(this.filaActual, this.registropagotipo, this.indexApobar)
                }else if(tipo === 2){
                    this.motivorechazo = false,
                    this.enviando = false,
                    this.$snotify.success(response.msg,'Exito'),
                    this.listaCobrosAprobadas(),
                    this.mostrarDetalles(this.filaActual, this.registropagotipo, this.indexApobar)
                }
            },
            detallesDocumento: function (row, tipo) {  
                let aprob = ''
                if(tipo === 1){
                    aprob = 'no'
                }else if(tipo === 2){
                    aprob = 'si'
                }
                this.viewdetails = true
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/recibidosxdocumento',{
                    token: this.$store.getters.userToken,
                    emisor: row.item.idEmisor,
                    aprobado: aprob
                })
                .then(response => (
                    this.parseDetallesDocumento(response.data.data, row, tipo)
                ))
                .catch(error => (  
                    this.viewdetails = false,
                    this.cuentasxAprobar[row.index].mostrardetalles = false,
                    this.cuentasAprobadas[row.index].mostrardetalles = false
                )) 
            },
            parseDetallesDocumento: function (value, row, tipo) {
                this.viewdetails = false
                if(tipo === 1){
                    this.cuentasxAprobar[this.indexApobar].detalles = value
                    this.cuentasxAprobar[this.indexApobar].loading = false
                    if(value.length > 0){
                    row.toggleDetails()
                    }
                }else if(tipo === 2){
                    this.cuentasAprobadas[this.indexApobado].detalles = value
                    this.cuentasAprobadas[this.indexApobado].loading = false
                    if(value.length > 0){
                    row.toggleDetails()
                    }
                }
            },
            listaCobrosxAprobar: function () {
                this.isBusy = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/recibidos',{
                    token: this.$store.getters.userToken,
                    aprobado: 'no',
                    page: this.currentPage,
                    limit: this.limite,
                    order: this.orden
                })
                .then(response => (
                    this.isBusy = false,
                    this.cuentasxAprobar = response.data.data,
                    this.total = response.data.total,
                    this.desde = response.data.from,
                    this.hasta = response.data.to,
                    this.cuentasxAprobar.forEach(function(element) {
                        element.loading = false
                    }) 
                ))
                .catch(error => {
                    this.isBusy = false
                })
            },
            listaCobrosAprobadas: function () {
                this.aprobados = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/recibidos',{
                    token: this.$store.getters.userToken,
                    aprobado: 'si',
                    page: this.currentPageA,
                    limit: this.limiteA,
                    order: this.ordenA
                })
                .then(response => (
                    this.aprobados = false,
                    this.cuentasAprobadas = response.data.data,
                    this.totalA = response.data.total,
                    this.desdeA = response.data.from,
                    this.hastaA = response.data.to,
                    this.cuentasAprobadas.forEach(function(element) {
                        element.loading = false
                    })   
                ))
                .catch(error => {
                    this.aprobados = false
                })
            }
        }
    }
</script>

<style>
    .negritatitle{
        font-size: 16px;
        font-weight: bold;
    }
</style>